import styled from "styled-components";

export const sidebarStyled = {
    sidebar: {
        zIndex: 2,
        position: "fixed",
        top: 0,
        bottom: 0,
        transition: "transform .3s ease-out",
        WebkitTransition: "-webkit-transform .3s ease-out",
        willChange: "transform",
        overflowY: "auto",
        background: 'black',
        width: '80%'
    },
    content: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflowY: "auto",
        WebkitOverflowScrolling: "touch",
        transition: "left .3s ease-out, right .3s ease-out"
    },
    overlay: {
        zIndex: 1,
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        opacity: 0,
        visibility: "hidden",
        transition: "opacity .3s ease-out, visibility .3s ease-out",
        backgroundColor: "rgba(0,0,0,.3)"
    },
    dragHandle: {
        zIndex: 1,
        position: "fixed",
        top: 0,
        bottom: 0,
        width: 0
    }
};

export const Logo = styled.img`
    max-height: 40px;
`;

export const Wrapper = styled.div`
    padding: 30px 0 0 20px;
    
`;